import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bf37b67"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-end position-fixed container-btn"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-up" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, onUnmounted, ref, UIEvent } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const scrollToTop = (): void => {
  window.scroll(0, 0)
}

const showIcon = ref<boolean>(false)

const handleScroll = (): UIEvent => {
  showIcon.value = window.scrollY > 150
}

onMounted(() => {
  document.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  document.removeEventListener('scroll', handleScroll)
})

return (_ctx: any,_cache: any) => {
  return (showIcon.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "shadow rounded-circle border border-white bg-white fs-6 btn-scroll-top mb-4",
          onClick: scrollToTop
        }, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}
}

})